import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { RouteComponentProps, withRouter } from 'react-router'

import classnames from 'classnames'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Employee } from 'src/lib/interfaces/Employee.interface'
import { Termination } from 'src/lib/interfaces/Termination.interface'

import { formatName } from 'src/lib/helpers/format'

import TerminationFlow from '../'
import TerminationFlowStatus from '../TerminationFlowStatus.type'
import TerminationFormData from '../TerminationFormData.interface'

import * as employeesActions from 'src/store/employees/actions'
import * as terminationsActions from 'src/store/terminations/actions'

export interface TerminationFlowModalProps extends RouteComponentProps {
  open: boolean
  employee: Employee
  onClose: () => void
  isCreatingTermination: boolean
  createTermination: (termination: TerminationFormData, next?: (err?: any, termination?: Termination) => void) => void
}

export interface TerminationFlowModalState {
  terminationForm?: TerminationFormData
}

const INITIAL_TERMINATION_FORM = {
  sendSurvey: true,
  reason: undefined,
  comments: undefined,
  voluntary: undefined,
  lastDayOfWork: undefined
}

class TerminationFlowModal extends React.Component<TerminationFlowModalProps, TerminationFlowModalState> {
  state: TerminationFlowModalState = {
    terminationForm: undefined
  }

  constructor(props: TerminationFlowModalProps) {
    super(props)

    this.state = {
      terminationForm: {
        ...INITIAL_TERMINATION_FORM,
        employee: props.employee
      }
    }

    this.handleClose = this.handleClose.bind(this)
    this.updateTerminationFlow = this.updateTerminationFlow.bind(this)
  }

  get employeeName() {
    if (this.props.employee.firstName) {
      return formatName(this.props.employee);
    }

    return null
  }

  handleClose() {
    this.setState({ terminationForm: {
      ...INITIAL_TERMINATION_FORM,
        employee: this.props.employee
    }}, this.props.onClose)
  }

  updateTerminationFlow(
    terminationState: TerminationFlowStatus,
    terminationForm?: TerminationFormData
  ) {
    if (!terminationState) {
      this.handleClose()
      return
    }

    if (terminationState === 'SUBMITTING') {
      this.setState({ terminationForm: undefined }, () => {
        this.props.createTermination(terminationForm!, (err?: any, termination?: Termination) => {
          this.handleClose()
          
          if (termination) {
            this.props.history.push(`/terminations/${termination.id}`)
          }
        })
      })

      return
    }

    this.setState(() => ({ terminationForm }))
  }

  render() {
    const { terminationForm } = this.state
    const { open, isCreatingTermination } = this.props

    return (
      <Modal isOpen={open} toggle={this.handleClose}>
        <ModalHeader toggle={this.handleClose}>Terminate {this.employeeName}</ModalHeader>
        <ModalBody>
          <TerminationFlow
            terminationForm={terminationForm!}
            statusCallback={this.updateTerminationFlow}
          />

          {isCreatingTermination &&
            <div style={{ height: '100px' }} className="d-flex align-items-center justify-content-center">
              <FontAwesomeIcon
                spin
                className="mr-3"
                icon={["fas", "spinner"]}
                style={{ fontSize: '35px'}}
              />
            </div>
          }
        </ModalBody>
      </Modal>
    )
  }
}

const mapStateToProps = ({ auth, employees, terminations }) => ({
  user: auth.user,
  isFetchingFiles: employees.isFetchingFiles,
  isCreatingTermination: terminations.isCreating
})

const mapDispatchToProps = dispatch => ({
  fetchEmployeeFiles: (employeeId: string) =>
    dispatch(employeesActions.fetchEmployeeFiles(employeeId)),
  createTermination: (termination: TerminationFormData, next?: (err?: any, termination?: Termination) => void) =>
    dispatch(terminationsActions.createTermination(termination, next))
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TerminationFlowModal))



// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationFlow.modal.tsx